
import React from 'react'
import { useDispatch } from 'react-redux'
import { Switch, useRouteMatch } from 'react-router-dom'

import { PrivateRoute } from '../../routes'
import Draft from './Draft'
import {useTranslation} from "react-i18next";

export const Routes = () => {
	const {t, i18n} = useTranslation();
	const {language: lang} = i18n;
	const dispatch = useDispatch();
	React.useEffect(() => {
		dispatch({
			type: 'SET_CONFIG_KEY',
			key: 'navbarTitle',
			value: t('nav_menu.section_menu.draft')
		})
	}, [dispatch, lang])
	const { path } = useRouteMatch();
	return <>
		<Switch>
			<PrivateRoute
				exact
				path={path}
				component={Draft}
				permission={''}
			/>
		</Switch>
	</>
}
export default Routes
